exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".header-row{margin-bottom:0px}.activityCenterTable .erjDfa{border-bottom:0}.activityCenterTable .rdt_Pagination{color:#000}.license{padding:20px 20px 20px 20px;z-index:2;height:100%;width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/ActivityCenter/ActivityCenter.scss
// module id = 1688
// module chunks = 101